<div
  class="fixed max-h-85-screen right-0 left-0 bottom-0 shadow-up-L overflow-y-auto bg-white rounded-t-3xl"
  [style.z-index]="(index$ | async) + 50"
>
  <app-push-modal-button-atom
    *ngIf="textWithButtonItem"
    [text]="textWithButtonItem.text"
    [title]="textWithButtonItem.title"
    [imgUrl]="textWithButtonItem.img"
    [isSafari]="isSafari"
    (yesButtonClick)="installPwa()"
    (noButtonClick)="close()"
  ></app-push-modal-button-atom>
</div>
